<modal #modal>
  <div *ngIf="ticketPackage !== null" class="product-info">
    <button type="button" class="product-info__close" role="button" aria-label="Luk" aria-roledescription="Luk modal"
      (click)="closeModal()">
      <img src="../../../../../assets/icons/close-b.svg" />
    </button>

    <div class="product-info__header">
      <div class="relative">
        <img src="{{'shop_ticket_image_focused_url_' + ticketPackage.Name | resource}}" />
        <span *ngIf="ticketPackage.Name === 'Millionpakken' || ticketPackage.Name === '1/2'" class="popular">
          Populært valg
        </span>
      </div>
      <div>
        <h2 class="product-info__heading">{{ticketPackage?.Name}}{{!isPackage ? '-lod' : ''}}</h2>
        <div class="product-info__semi-bold">Topgevinst {{ ("global_package_topprize_text_" +
          ticketPackage.Name) | resource}}</div>
        <div>Mindste gevinst {{ ("global_package_minprize_text_" + ticketPackage.Name) | resource}}</div>
      </div>
    </div>

    <div *ngIf="isPackage" class="product-info__ribbon">
      <div class="product-info__ribbon__content">
        <div *ngFor="let ticket of ticketPackage.TicketPackageContents " class="product-info__row">
          <div>{{ticket.NumberOfTickets}}x {{ticket.TicketShareType.Name}}-lod</div>
          <div>{{ ticket.pricePrMonth | money }}</div>
        </div>

        <div class="product-info__row product-info__row--total">
          <div>Pris i alt</div>
          <div>{{totalPricePrMonth | money}} / md</div>
        </div>
      </div>
      <div class="product-info__images">
        <ng-container *ngFor="let ticket of ticketPackage.TicketPackageContents">
          <img *ngFor="let numberOfTickets of [].constructor(ticket.NumberOfTickets)"
            src="{{'shop_ticket_image_small_url_' + ticket.TicketShareType.Name | resource}}" />
        </ng-container>
      </div>
    </div>



    <div class="product-info__content">
      <div *ngIf="!isPackage">
        <div class="product-info__row product-info__row--total">
          <div>Pris i alt</div>
          <div>{{pricePrMonth | money }} / md</div>
        </div>
      </div>

      <h2 class="product-info__subheading">Gevinstchance</h2>

      <p>{{("shop_purchase_package_list_chance_" + ticketPackage.Name) | resource}}</p>

      <div class="product-info__prizes-list">
        <div class="product-info__prizes-row product-info__prizes-row--header">
          <div>Gevinster</div>
          <div>Antal</div>
        </div>

        <div *ngFor="let prizeRow of prizesTable.prizes" class="product-info__prizes-row">
          <div>{{prizeRow.prize | money}}</div>
          <div>{{prizeRow.amount | number}}</div>
        </div>

      </div>
      <h3 class="product-info__fee-heading">Gevinstafgift</h3>

      <p class="product-info__fee-text">Der skal efter gældende lov betales en afgift på 15% af den del af hver
        enkelt gevinst, der overstiger 200 kr. Gevinstafgiften er fratrukket, inden gevinsten udbetales. Det
        betyder, at du ved en gevinst på 300 kr. vil få udbetalt 285 kr.</p>

    </div>
  </div>
</modal>